import React from "react";

import {
  Outlet
} from "react-router-dom";

const VacationWrapper = props => {

  return (
    <Outlet/>
  );
}

export default VacationWrapper;